import { IApplicationState } from '../../types/redux';

export const selectSuggestions = (state: IApplicationState) => {
  return state.suggestions.list;
};

export const selectSuggestionsLoading = (state: IApplicationState) => {
  return state.suggestions.loading;
};
